import {CxEvent} from '@spartacus/core';

export class EddlStlBeaconEvent extends CxEvent {
  static readonly type = 'EddlStlBeaconEvent';
}
